<script>
/**
 * Contents component
 */
export default {
  data() {
    return {
      year:'',
    }
  },
  created() {
    this.year = new Date().getFullYear()
  }
}
</script>
<template>
  <!-- Footer Start -->
  <footer class="footer">
    <div class="container-fluid px-4">
      <div class="row">
        <div class="col-md-6 p-0">
          Copyright &copy; {{year}} Workmotion Corp
        </div>
        <div class="col-md-6 text-lg-right p-0">
          Copyright &copy; {{year}} CHOWJUNG CO., LTD.
        </div>
      </div>
    </div>
  </footer>
  <!-- end Footer -->
</template>
